import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import textExample7 from './assets/images/text-example7.png'

const CSSLesson28 = () => {
  const [language, changeLanguage] = useState("css");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
   h1 {
    letter-spacing: 3px;
   }

   h1 {
    letter-spacing: -3px;
   }
  `
  );
  const code1 = (
  'text',
  `
   p.small {
    line-height: 30.8;
   }

   p.big {
    line-height: 1.8;
   }
  `
  );
  const code2 = (
  'text',
  `
   h1 {
    word-spacing: 10px;
   }

   h2 {
    word-spacing: -5px;
   }
  `
  );
  const code3 = (
  'text',
  `
   h1 {
    text-shadow: 3px 2px red;
   }

   
  `
  );


  return (
    <HTMLCourseNavProvider>
      <div className="container">
        <div className="row">
          <div>
            <SideBar />
          </div>

          <div className="alert alert-secondary" role="alert">
          <h3><strong>Letter Spacing</strong></h3>
<p>The <b class="text-danger">letter-spacing</b> property is used to specify the space between the characters in a text.</p>
<CopyBlock
    language={"css"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <p>The letter-spacing property controls the amount of space between each letter in a given element or block of text. Values supported by letter-spacing include font-relative values (em, rem), absolute values (px) and the normal property, which resets to the font’s default.</p>
    </div>


    <div className="alert alert-secondary" role="alert">
<h3><strong>Line Height</strong></h3>
<p>The <b class="text-danger">line-height</b> property is used to specify the space between lines.</p>
<CopyBlock
    language={"css"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

<div className="alert alert-secondary" role="alert">
<h3><strong>Word Spacing</strong></h3>
<p>The <b class="text-danger">word-spacing</b> property is used to specify the space between the words in a text.</p>
<CopyBlock
    language={"css"}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

<div className="alert alert-secondary" role="alert">
<h3><strong>Text Shadow</strong></h3>
<p>The <b class="text-danger">text-shadow</b> property adds shadow to a text.</p>
<CopyBlock
    language={"css"}
    text={code3}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />  
    </div>               
                    


                          </div>
        </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSLesson28;
